import { ProductStockStatus } from '@pylot-data/enums/ProductStockStatus.d'
import { useTranslation } from 'next-i18next'
import { BundleTypeProps } from './type'
import { sortAlphabetically } from '@components/alfakher/pylot-utils'
import { MediaGalleryInterface } from '@pylot-data/fwrdschema'
import { getDynamicPriceToAdd } from '@components/BundleProduct/Util/Prices'
import { BundleItemOption } from '@pylot-data/pylotschema'

export const MultiSelect = ({
    selectedBundleProducts,
    setSelectedBundleProducts,
    bundleItem,
    setSelectedLabels,
    selectedLabels,
    dynamicPrice,
    currency,
    locale,
    mainFinalPrice,
    useFlavour = false
}: BundleTypeProps) => {
    const { options, uid, required } = bundleItem
    const { t } = useTranslation('common')
    const filteredProduct = bundleItem.options?.filter((val) => {
        if (val?.label) {
            return val
        }
    })
    const sortedValues = filteredProduct?.sort((a, b) =>
        sortAlphabetically(a?.label, b?.label)
    )
    const isInstock = options?.find(
        (res) => res?.product?.stock_status === 'IN_STOCK'
    )
    return (
        <div>
            {/* eslint-disable-next-line jsx-a11y/no-onchange */}
            <select
                className="border-2 text-sm border-secondary block appearance-none w-full bg-grey-lighter text-p-1 py-3 pl-4 pr-8 rounded focus:shadow-none focus:outline-none max-w-sm"
                id="grid-state"
                // @ts-ignore
                defaultValue={
                    options?.filter((i) => i?.is_default).map((i) => i?.uid) ||
                    []
                }
                onChange={(e) => {
                    e.persist()
                    const labels: string[] = []
                    let selectedGallery: MediaGalleryInterface[] = []
                    const selectedUidArray = Array.from(
                        e.target.selectedOptions,
                        (item) => {
                            const selectedOption = options?.find(
                                (option) => option?.uid === item.value
                            )
                            if (selectedOption) {
                                selectedGallery = selectedGallery.concat(
                                    selectedOption?.product
                                        ?.media_gallery as MediaGalleryInterface
                                )
                            }
                            const getFlavour = () => {
                                const flavour = selectedOption?.product
                                    ?.flavour_text
                                    ? selectedOption?.product.flavour_text
                                    : ''

                                if (!flavour) {
                                    return getLabel()
                                }

                                return flavour
                            }
                            const getLabel = () => {
                                return selectedOption?.label
                                    ? selectedOption?.label
                                    : ''
                            }
                            labels.push(
                                (useFlavour
                                    ? getFlavour()
                                    : getLabel()) as string
                            )
                            return {
                                multiSelectUid: item.value,
                                value: selectedOption?.quantity ?? 1
                            }
                        }
                    )
                    setSelectedBundleProducts(
                        {
                            ...selectedBundleProducts,
                            [uid as string]: {
                                uid: selectedUidArray
                            }
                        },
                        selectedGallery
                    )
                    setSelectedLabels({
                        ...selectedLabels,
                        [uid as string]: labels
                    })
                }}
                multiple
            >
                {!required && <option value="">{t('None')}</option>}
                {sortedValues?.map((v, i: number) => {
                    const getOption = () => {
                        const flavourText = v?.product?.flavour_text

                        if (useFlavour && flavourText) {
                            return flavourText
                        }

                        return v?.label
                    }
                    const values: string = v?.product?.stock_status ?? ''
                    const OutOfstockValue: boolean = ProductStockStatus.OutOfStock.includes(
                        values
                    )
                    if (!OutOfstockValue) {
                        return (
                            <option
                                disabled={
                                    v?.product?.stock_status ===
                                    ProductStockStatus.OutOfStock
                                }
                                key={`${v?.uid}-${i}`}
                                value={v?.uid}
                            >
                                {getOption()}
                                {getDynamicPriceToAdd(
                                    v as BundleItemOption,
                                    dynamicPrice,
                                    currency,
                                    locale,
                                    mainFinalPrice
                                )}
                            </option>
                        )
                    }
                })}
                {!isInstock && (
                    <option value="">
                        {t('All options are out of stock')}
                    </option>
                )}
            </select>
        </div>
    )
}
